import { render, staticRenderFns } from "./ViewMenu.vue?vue&type=template&id=5211f897&scoped=true&"
import script from "./ViewMenu.vue?vue&type=script&lang=js&"
export * from "./ViewMenu.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5211f897",
  null
  
)

export default component.exports